/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Table_RequestsInputs */

const en_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests / mo`)
};

const zh_hans1_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请求数 / 月`)
};

const pt_br2_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requisições / mês`)
};

const es_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes / mes`)
};

const fr_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requêtes / mois`)
};

const de_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen / Monat`)
};

const ru_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросов / мес.`)
};

const it_platform_table_requests = /** @type {(inputs: Platform_Table_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richieste / mese`)
};

/**
* | output |
* | --- |
* | "Requests / mo" |
*
* @param {Platform_Table_RequestsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_table_requests = /** @type {((inputs?: Platform_Table_RequestsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Table_RequestsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_table_requests(inputs)
	if (locale === "pt-BR") return pt_br2_platform_table_requests(inputs)
	if (locale === "es") return es_platform_table_requests(inputs)
	if (locale === "fr") return fr_platform_table_requests(inputs)
	if (locale === "de") return de_platform_table_requests(inputs)
	if (locale === "ru") return ru_platform_table_requests(inputs)
	if (locale === "it") return it_platform_table_requests(inputs)
	return en_platform_table_requests(inputs)
});